export const DEPLOYED_JAVASCRIPT = '__DEPLOYED_JAVASCRIPT__';
export const DEPLOYED_JAVASCRIPT_BREAKING = '__DEPLOYED_JAVASCRIPT_BREAKING__';
export const DEPLOYED_JAVASCRIPT_TIMESTAMP = '__DEPLOYED_JAVASCRIPT_TIMESTAMP__';